import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import JumpToTop from "../../../helpers/jumpToTop";

export interface NavLinkItem {
  name: string;
  path: string;
}

interface NavLinksProps {
  navLinks: NavLinkItem[];
  navLinksClassName: string;
  navLinkClassName: string;
  navLinkActiveClassName: string;
}

const NavLinks: FC<NavLinksProps> = ({
  navLinks,
  navLinksClassName,
  navLinkClassName,
  navLinkActiveClassName,
}) => {

  return (
    <>

      <ul className={navLinksClassName}>
        {navLinks.map((link: NavLinkItem) => (
          <li key={link.path}>
            <NavLink
                onClick={JumpToTop}
              to={link.path}
              className={({ isActive }) =>
                isActive ? navLinkActiveClassName : navLinkClassName
              }
            >
              {link.name}
            </NavLink>
          </li>
        ))}

      </ul>
    </>
  );
};

export default NavLinks;
